import { useCallback, useMemo, useState } from "react";
import type { ReactNode } from "react";
import { CreateShiftContext, type CreateShiftPrefill } from "./createShiftContext";
import { CreateShiftModal } from "./CreateShiftModal";

export function CreateShiftProvider({ children }: { children: ReactNode }) {
  const [prefill, setPrefill] = useState<CreateShiftPrefill | null>(null);

  const openCreateShift = useCallback((next?: CreateShiftPrefill) => {
    setPrefill(next ?? {});
  }, []);

  const value = useMemo(() => ({ openCreateShift }), [openCreateShift]);

  return (
    <CreateShiftContext.Provider value={value}>
      {children}
      {prefill && (
        <CreateShiftModal
          open
          onOpenChange={(next) => !next && setPrefill(null)}
          onSuccess={prefill.onSuccess}
          defaults={prefill}
        />
      )}
    </CreateShiftContext.Provider>
  );
}
